import { render, staticRenderFns } from "./intermediaries.vue?vue&type=template&id=6b4d4786"
import script from "./intermediaries.vue?vue&type=script&lang=js"
export * from "./intermediaries.vue?vue&type=script&lang=js"
import style0 from "./intermediaries.vue?vue&type=style&index=0&id=6b4d4786&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports